import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'

import Vue from 'vue'
import './uni.promisify.adaptor'
import tool from '@/utils/tool.js';
import share from './utils/wxShare.js'
Vue.prototype.baseImgURL = 'https://xoil-public.oss-cn-beijing.aliyuncs.com/xoilcharge';
Vue.mixin(share)
// import QQMapWX from 'utils/qqmap-wx-jssdk.min.js'
Vue.config.productionTip = false;
Vue.prototype.tool = tool;
Vue.prototype.globalData = {
	version: "Ⅰ"
};
App.mpType = 'app';
const app = new Vue({
	...App
});
app.$mount();
// console.log()